import {useCountVouchersQuery} from "@MyProfile/API/myProfileApi";

export default function useCountArchivedVouchers() {
    const {
        data,
        isUninitialized,
        isLoading,
        isFetching,
    } = useCountVouchersQuery({showArchived: true})

    const archivedVouchersCountLoading = isUninitialized || isLoading || isFetching

    return {
        archivedVouchersCount: data?.count,
        archivedVouchersCountLoading,
    }
}